import React from 'react';
import { ref } from '@dbk-legacy/muster/utils';
import { createContainer } from '@dbk-legacy/muster/react';
import ProfileContainer from '../profile-page-container';

const ProfilePortfolioPage = (props) => {
  const {
    items,
    i18n: { messages },
    portfolioCount
  } = props;

  return (
    <ProfileContainer
      items={items}
      title={messages['app.common.pageTitle.preferences']}
      portfolioCount={portfolioCount}
    />
  );
}

export default createContainer(
  {
    $queries: {
      app: {
        user: {
          profile: {
            portfolio: {
              $type: 'list',
              $range: {
                offset: 0,
                length: ref('app.user.profile.portfolio.length'),
              },
              $node: {
                key: true,
                title: true,
                type: true,
              },
            }
          },
          portfolios: {
            length: true,
          },
        },
      },
      i18n: {
        messages: true,
      },
    },
  },
  ({ ui, app, ...queries }) => ({
    ...queries,
    items: app.user.profile.portfolio,
    portfolioCount: app.user.portfolios.length,
    // notificationEntitlement: app.user.entitlement.notification.read,
  })
)(ProfilePortfolioPage);

export { ProfilePortfolioPage };
